import { defaultVisualEtiqueta, initialDataLabelsBaker,initialMeasures,defaultpdfTE } from "./state";
import { getAcls } from '../../../plugins/acl';

export function setListarEmpresas(state, empresas) {
    state.empresas = empresas
}

export function setLimpiar(state) {
    state.check_qr = 1;
    state.mini = 0
}

export function setEtiquetasArchivo(state, etiquetasArchivo) {
    state.etiquetasArchivo = etiquetasArchivo;
}

export function setDatosEmpresa(state, dato) {
    state.selectedEmpresa = dato;

}

export function setMedidaEtiquetaTexto(state, texto) {
    state.medidaEtiquetaTexto = texto;
}

/**
 * Mutación para limpiar el formulario de la generación de etiquetas.
 *
 * @export
 * @param {*} state
 */
export function resetVisualEmpresa(state) {
    state.VisualEmpresa = defaultVisualEtiqueta();
}

/**
 * Mutación para determinar si hubo un error en alguna consulta.
 *
 * @export
 * @param {*} state
 * @param {*} error contiene un booleano
 */
export function setError(state, error) {
    state.error = error;
}

export function empresaDatosError(state) {
    console.log(state);
    console.log('empresaDatosError');
}
/**
 * Mutación para asignar las etiquetas procesadas por el usuario
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} etiquetas contiene la información de las etiquetas procesadas.
 */
export function setEtiquetasAgendadas(state, etiquetas) {
    state.etiquetasProcesadas = etiquetas.map((element) => {
        const temp = state.medidas.find((medida) => medida.value === element.tipo);
        if (temp) {
          return { ...element, tipo: temp.text };
        } else {
          return element;
        }
      });
}

/**
 * Mutación que carga las empresas a las ET.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} optempresa contiene la información de las empresas.
 */
export function cargarEmpresas(state, optempresa) {

    state.optempresa = [];

    for (var i = 0; i < optempresa.length; i++) {
        state.optempresa.push({ value: optempresa[i].id, text: optempresa[i].nombre });
    }
}

/**
 * Mutación que carga las data a las ET.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} optempresa contiene la información de las empresas.
 */
export function cargarData(state, data) {

    state.pdfet = {...data}

    state.pdfet.empresa = data.empresa;
    state.pdfet.idioma = data.idioma;
    state.pdfet.version = data.version;
    state.pdfet.regla = data.regla;
    state.pdfet.fabfecha = data.fabfecha;
    state.pdfet.rol = data.rol;
    state.pdfet.tipoproducto = data.tipoproducto;
    state.pdfet.cabecera = data.cabecera;
    state.pdfet.tipoEtiqueta = data.tipoEtiqueta;
    state.pdfet.cantidad = data.cantidad;
    state.pdfet.qr = data.qr;
    state.pdfet.loteCantidadCodigo = data.loteCantidadCodigo;
}

/**
 * Mutación para asignar los parámetros para generar las etiquetas.
 *
 * @export
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} data contiene la información del formulario.
 */
export function asignarParametrosEtiqueta(state, data) {
    Object.assign(state.pdfet, data);
}

/**
 * Mutación para asignar el uuid del usuario al agendamiento de inventarios.
 *
 * @export
 * @param {*} state
 */
 export function setUuid(state) {
    const acls = getAcls();

    if (acls && acls.uuid){
        Object.assign(state.pdfet, {uuid: acls.uuid})
    }
}

export function etiquetaError(state, error) {
    console.log(error);
    console.log('etiquetaError');
}

export function etiquetaLink(state, link) {
    state.dirEtiqueta = link

}

export function setAdvertenciaEtMultiple(state, advertencia) {
    state.advertenciaEtMultiple = advertencia;
}

export function establecerEmpresas(state, empresas) {
  state.empresas = empresas;
}

export function establecerCargandoDatosSelect(state, cargando_datos_select) {
  state.cargando_datos_select = cargando_datos_select;
}

/**
 * Muta el estado a true o false
 *
 * @param {*} state contiene la informacion.
 * @param {*} asignada contiene la información ingresada como parametro.
 */

//
export function establecerAsignada(state, asignada) {
    state.empresaAsignada = asignada;
  }


/**
 * Setear la nuev data de las etiquetas Baker.
 *
 * @param {*} state
 * @param {*} newData
 * @return void
 * @author Fernando Claros
 */
export function setDataLabelsBaker(state, newData) {
    state.dataLabelsBaker.company   = newData.company
    state.dataLabelsBaker.useQr     = newData.useQr
    state.dataLabelsBaker.useRule   = newData.useRule
    state.dataLabelsBaker.typeLabel = newData.typeLabel
    state.dataLabelsBaker.cant      = newData.cant
    state.dataLabelsBaker.configurableVariables   = newData.configurableVariables
    state.dataLabelsBaker.configurableVariablesId = newData.configurableVariablesId
    state.dataLabelsBaker.orientation = newData.orientation || 'portrait'
}

/**
 * Resetear los datos de propiedades para las etiquetas Baker.
 *
 * @param {*} state
 * @return void
 * @author Fernando Claros
 */
export function resetDataLabelsBaker(state) {
    state.dataLabelsBaker = initialDataLabelsBaker();
}

/**
 * Establecer la horientación.
 *
 * @param {*} state
 * @param {*} nextOrientation
 * @return void
 * @author Fernando Claros
 */
export function setLabelOrientation(state, nextOrientation) {
    state.orientation = nextOrientation;
}

/**
 * Setear etiquetas a descargar según empresa.
 *
 * @param {*} state
 * @param {*} labels
 * @return void
 */
export function setLabelsToDownload(state, labels) {
    state.medidas = labels;
}

/**
 * Resetear los datos de de las medidas para et masivas.
 * @param {*} state
 * @return void
 */
export function resetDataMeasures(state) {
    state.medidas = initialMeasures();
}

/**
 * Resetear los datos de de las medidas para et masivas.
 * @param {*} state
 * @return void
 */
export function resetDataPdfTE(state) {
    state.pdfet = defaultpdfTE();
}
